import React, {useCallback, useContext} from 'react';

import {MessageContext} from 'src/contexts/message-context';

import {FlatButton} from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';
import {useShown} from '@pb/kit-hooks-use-shown';


import {RemoveConferencesModal} from './remove-conferences-modal';

type Props = {
    userId: number,
    conferenceIds: number[],
    onDone: () => void,
};

export const RemoveConferencesTool = ({userId, conferenceIds, onDone}: Props) => {
    const {setSuccessMessage} = useContext(MessageContext);
    const {shown, onClick, onClose} = useShown();

    const onSuccess = useCallback(() => {
        setSuccessMessage('Conferences removed successfully');
        onDone();
        onClose();
    }, [onDone, setSuccessMessage, onClose]);

    return (
        <>
            <FlatButton onClick={onClick}>
                <b>Remove From Conference</b>
            </FlatButton>
            <Dialog
                shown={shown}
                setShown={onClose}>
                <RemoveConferencesModal
                    userId={userId}
                    conferenceIds={conferenceIds}
                    onSuccess={onSuccess}
                    onClose={onClose}
                />
            </Dialog>
        </>
    );
};
